import { useQuery } from '@tanstack/react-query';
import services from 'services/services';

/**
 * Query hook for fetching panel property groups.
 *
 * Groups are workspace-scoped; each group has { id, name, order } and is
 * used to label the section headers in the Show Panel Properties modal.
 *
 * @param {Object} [options] - Additional useQuery options
 * @returns {Object} useQuery result object
 */
export function usePanelPropertiesGroupsQuery(options = {}) {
    return useQuery({
        queryKey: ['panel-properties-groups'],
        queryFn: () => services.getPanelPropertiesGroups(),
        ...options
    });
}
